export const DATADOG_RUM_APPLICATION_ID = '07cb33e6-01c9-4e12-a283-32aadc7c89ef';
export const DATADOG_RUM_CLIENT_TOKEN = 'pube8caa567c22599f1c8a1a1c2392b2aef';
